// extracted by mini-css-extract-plugin
module.exports = {"mailContainer":"TemplateMessage_mailContainer__1McuC","smsContainer":"TemplateMessage_smsContainer__2fSG2"};